// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__GgUsq","title":"Info_title__34k4E","links":"Info_links__3Zaqj","link":"Info_link__1BnDp","logo":"Info_logo__2S2nb"};